<template>
  <v-row>
    <v-col>
      <v-row align="center" class="mb-4">
        <v-col>
          <v-alert
            v-if="saveError"
            type="error"
            dense
            class="mb-0"
          >
            Não foi possível salvar no momento. Tente novamente.
          </v-alert>

          <v-alert
            v-else-if="hasUnsavedChanges"
            type="warning"
            dense
            class="mb-0"
          >
            <strong>
              Alterações não salvas. Salve antes de mudar de aba.
            </strong>
          </v-alert>
        </v-col>

        <v-col cols="auto">
          <v-btn
            color="primary"
            :loading="saving"
            :disabled="
              disabled ||
              saving ||
              !hasUnsavedChanges
            "
            @click="saveSurgeryIntraoperative"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>

            Salvar
          </v-btn>
        </v-col>
      </v-row>

      <Allergy
        :attendance="attendance"
        :showForm="false"
        :allowDelete="false"
      />

      <SurgeryDetail
        :surgery="surgery"
      />

      <ProsthesisList
        :surgeryIndicationProstheses="
          surgery.surgeryIndication.prostheses
        "
        :surgeryIndication="
          surgery.surgeryIndication
        "
        :showForm="false"
        :onlyChosen="true"
        :allowDelete="false"
        :allowEdit="false"
        @update-surgery-indication-prostheses="
          updateProstheses
        "
      />

      <v-row>
        <v-col class="text-h5 gray--text">
          Equipe
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="6">
          <v-combobox
            v-model="surgeon"
            label="Cirurgião"
            dense
            hide-details
            outlined
            :items="doctorUsers"
            item-text="employee.name"
            background-color="white"
            :disabled="disabled"
            @change="handleMainChange"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            v-model="pharmaceutical"
            label="Farmacêutico"
            dense
            hide-details
            outlined
            :items="pharmaceuticalUsers"
            item-text="employee.name"
            background-color="white"
            :disabled="disabled"
            @change="handleMainChange"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            v-model="instrumentator"
            label="Instrumentador"
            dense
            hide-details
            outlined
            :items="nurseUsers"
            item-text="employee.name"
            background-color="white"
            :disabled="disabled"
            @change="handleMainChange"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            v-model="floating"
            label="Circulante"
            dense
            hide-details
            outlined
            :items="nurseUsers"
            item-text="employee.name"
            background-color="white"
            :disabled="disabled"
            @change="handleMainChange"
          />
        </v-col>

        <v-col cols="6">
          <v-combobox
            v-model="assistants"
            label="Auxiliares"
            dense
            hide-details
            outlined
            :items="doctorUsers"
            item-text="employee.name"
            multiple
            chips
            deletable-chips
            small-chips
            background-color="white"
            :disabled="disabled"
            @change="handleMainChange"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text">
              Descrição
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="descriptionModel"
                label="Cirurgia"
                dense
                hide-details
                outlined
                :items="descriptionModels"
                item-text="name"
                background-color="white"
                :disabled="disabled"
              />
            </v-col>

            <v-col>
              <v-combobox
                v-model="descriptionTemplate"
                label="Modelo"
                dense
                hide-details
                outlined
                :items="descriptionModelTemplates"
                item-text="name"
                background-color="white"
                :disabled="disabled"
                @change="choseDescriptionTemplate"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <RichText
                v-model="description"
                :disabled="disabled"
                @change="handleMainChange"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-h5 gray--text">
          Anexos Cirurgia
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <FileUpload
            ownerType="Surgery::Intraoperative"
            :ownerId="surgery.intraoperative.id"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <SurgeryProsthesisList
        :surgery="surgery"
        :refreshProstheses="refreshSurgery"
        :disabled="disabled"
      />

      <SurgeryIntraoperativeAnesthesia
        ref="anesthesia"
        :attendance="attendance"
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :doctorUsers="doctorUsers"
        :nurseUsers="nurseUsers"
        :disabled="disabled"
        @dirty-change="
          handleAnesthesiaDirtyChange
        "
      />

      <SurgeryVitalMeasurementList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <SurgeryTherapyList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text">
              Notas
            </v-col>
          </v-row>

          <RichText
            v-model="observation"
            :disabled="disabled"
            @change="handleMainChange"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ProsthesisList from "@/components/surgery_indication/prosthesis/list/index.vue";
import Allergy from "@/components/medical_record/hpp/allergy.vue";
import SurgeryDetail from "@/components/surgery/detail.vue";
import SurgeryIntraoperativeAnesthesia from "@/components/surgery/intraoperative/anesthesia.vue";
import SurgeryProsthesisList from "@/components/surgery/intraoperative/prosthesis/list/index.vue";
import SurgeryVitalMeasurementList from "@/components/surgery/vital_measurement/list/index.vue";
import SurgeryTherapyList from "@/components/surgery/therapy/list/index.vue";

export default {
  name: "SurgeryIntraoperative",

  props: {
    surgery: Object,
    refreshSurgery: Function,
    setSurgeryMoment: Function,
    surgeryMoment: String,

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ProsthesisList,
    Allergy,
    SurgeryDetail,
    SurgeryIntraoperativeAnesthesia,
    SurgeryProsthesisList,
    SurgeryVitalMeasurementList,
    SurgeryTherapyList,
  },

  data() {
    return {
      initializing: true,
      saving: false,
      saveError: null,

      /*
       * Dirty state do formulário principal.
       */
      initialMainSnapshot: null,
      mainDirty: false,

      /*
       * Dirty state informado pelo componente
       * filho de anestesia.
       */
      anesthesiaDirty: false,

      surgeon: null,
      pharmaceutical: null,
      floating: null,
      instrumentator: null,
      assistants: [],

      description: "",
      observation: "",

      descriptionModel: null,
      descriptionTemplate: null,
    };
  },

  async mounted() {
    this.initializing = true;

    this.description =
      this.intraoperative.description || "";

    this.observation =
      this.intraoperative.observation || "";

    this.setSurgeryMoment("intraoperative");

    /*
     * Faz uma primeira tentativa de preencher a equipe.
     * Caso os usuários ainda não tenham chegado, o
     * callback do Apollo fará nova hidratação.
     */
    this.loadUsers();

    await this.$nextTick();

    /*
     * O estado carregado passa a ser o baseline.
     */
    this.captureMainSnapshot();

    this.initializing = false;
  },

  apollo: {
    users: {
      query: require("@/graphql/users.gql"),

      result() {
        /*
         * Os usuários chegam de forma assíncrona.
         * Esse preenchimento não representa edição.
         */
        this.hydrateMainUsers();
      },
    },

    surgeryIntraoperativeSurgeryTemplates: {
      query: require(
        "@/graphql/surgery/surgery_intraoperative_surgery_templates.gql"
      ),
    },
  },

  computed: {
    /*
     * Um único alerta e botão representam os dois
     * formulários: principal e anestesia.
     */
    hasUnsavedChanges() {
      return (
        this.mainDirty ||
        this.anesthesiaDirty
      );
    },

    attendance() {
      return this.surgery.attendance;
    },

    intraoperative() {
      return this.surgery.intraoperative;
    },

    doctorUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(
          this.users || [],
          {
            employee: {
              employeeType: "doctor",
            },
          }
        ),
        [
          (user) =>
            (
              user.employee?.name || ""
            )
              .toLowerCase()
              .normalize("NFD")
              .replace(
                /[\u0300-\u036f]/g,
                ""
              ),
        ],
        ["asc"]
      );
    },

    nurseUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(
          this.users || [],
          {
            employee: {
              employeeType: "nurse",
            },
          }
        ),
        [
          (user) =>
            (
              user.employee?.name || ""
            )
              .toLowerCase()
              .normalize("NFD")
              .replace(
                /[\u0300-\u036f]/g,
                ""
              ),
        ],
        ["asc"]
      );
    },

    pharmaceuticalUsers() {
      return this.lodash.filter(
        this.users || [],
        {
          employee: {
            employeeType: "pharmaceutical",
          },
        }
      );
    },

    descriptionModels() {
      return this.lodash.uniqBy(
        this.lodash.map(
          this.surgeryIntraoperativeSurgeryTemplates ||
            [],
          "surgery"
        ),
        "id"
      );
    },

    descriptionModelTemplates() {
      if (!this.descriptionModel?.id) {
        return [];
      }

      return this.lodash.filter(
        this.surgeryIntraoperativeSurgeryTemplates ||
          [],
        (template) =>
          template.surgery.id ===
          this.descriptionModel.id
      );
    },
  },

  methods: {
    normalizeId(value) {
      if (
        value === null ||
        value === undefined ||
        value === ""
      ) {
        return null;
      }

      return String(value);
    },

    /*
     * Normaliza diferenças de representação
     * produzidas pelo editor RichText.
     */
    normalizeRichText(value) {
      let normalized = String(value || "")
        .replace(/\u00a0/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(
          /<(p|div)>\s*(<br\s*\/?>)?\s*<\/\1>/gi,
          ""
        )
        .replace(/>\s+</g, "><")
        .trim();

      /*
       * Considera equivalente:
       *
       * Texto
       *
       * e:
       *
       * <p>Texto</p>
       */
      if (
        /^<p>[\s\S]*<\/p>$/i.test(
          normalized
        ) &&
        !/<\/p>\s*<p>/i.test(normalized)
      ) {
        normalized = normalized
          .replace(/^<p>/i, "")
          .replace(/<\/p>$/i, "")
          .trim();
      }

      if (
        /^<div>[\s\S]*<\/div>$/i.test(
          normalized
        ) &&
        !/<\/div>\s*<div>/i.test(
          normalized
        )
      ) {
        normalized = normalized
          .replace(/^<div>/i, "")
          .replace(/<\/div>$/i, "")
          .trim();
      }

      return normalized;
    },

    createMainSnapshot() {
      return JSON.stringify({
        surgeonId: this.normalizeId(
          this.lodash.get(
            this.surgeon,
            "id",
            null
          )
        ),

        pharmaceuticalId: this.normalizeId(
          this.lodash.get(
            this.pharmaceutical,
            "id",
            null
          )
        ),

        floatingId: this.normalizeId(
          this.lodash.get(
            this.floating,
            "id",
            null
          )
        ),

        instrumentatorId: this.normalizeId(
          this.lodash.get(
            this.instrumentator,
            "id",
            null
          )
        ),

        assistantIds: this.lodash
          .map(
            this.assistants || [],
            "id"
          )
          .map((id) =>
            this.normalizeId(id)
          )
          .filter(Boolean)
          .sort(),

        description: this.normalizeRichText(
          this.description
        ),

        observation: this.normalizeRichText(
          this.observation
        ),
      });
    },

    captureMainSnapshot() {
      this.initialMainSnapshot =
        this.createMainSnapshot();

      this.mainDirty = false;
    },

    updateMainDirtyState() {
      if (
        this.initializing ||
        this.initialMainSnapshot === null
      ) {
        return;
      }

      this.mainDirty =
        this.createMainSnapshot() !==
        this.initialMainSnapshot;
    },

    handleMainChange() {
      if (
        this.initializing ||
        this.disabled ||
        this.saving
      ) {
        return;
      }

      /*
       * Aguarda o v-model receber o valor final
       * antes de realizar a comparação.
       */
      this.$nextTick(() => {
        this.updateMainDirtyState();
        this.saveError = null;
      });
    },

    handleAnesthesiaDirtyChange(isDirty) {
      this.anesthesiaDirty =
        Boolean(isDirty);

      this.saveError = null;
    },

    loadUsers() {
      if (
        this.intraoperative.surgeon?.id
      ) {
        this.surgeon = this.lodash.find(
          this.doctorUsers || [],
          {
            id:
              this.intraoperative.surgeon.id,
          }
        );
      } else {
        this.surgeon = null;
      }

      if (
        this.intraoperative
          .pharmaceutical?.id
      ) {
        this.pharmaceutical =
          this.lodash.find(
            this.pharmaceuticalUsers || [],
            {
              id:
                this.intraoperative
                  .pharmaceutical.id,
            }
          );
      } else {
        this.pharmaceutical = null;
      }

      if (
        this.intraoperative.floating?.id
      ) {
        this.floating = this.lodash.find(
          this.nurseUsers || [],
          {
            id:
              this.intraoperative.floating.id,
          }
        );
      } else {
        this.floating = null;
      }

      if (
        this.intraoperative
          .instrumentator?.id
      ) {
        this.instrumentator =
          this.lodash.find(
            this.nurseUsers || [],
            {
              id:
                this.intraoperative
                  .instrumentator.id,
            }
          );
      } else {
        this.instrumentator = null;
      }

      const assistantIds = this.lodash
        .map(
          this.intraoperative.assistants ||
            [],
          "id"
        )
        .map((id) =>
          this.normalizeId(id)
        )
        .filter(Boolean);

      this.assistants =
        this.lodash.filter(
          this.doctorUsers || [],
          (user) =>
            assistantIds.includes(
              this.normalizeId(user.id)
            )
        );
    },

    async hydrateMainUsers() {
      /*
       * Não sobrescreve uma alteração
       * iniciada pelo operador.
       */
      if (this.mainDirty) {
        return;
      }

      const previousInitializingState =
        this.initializing;

      this.initializing = true;

      try {
        this.loadUsers();

        await this.$nextTick();

        /*
         * A chegada da lista de usuários faz
         * parte da hidratação inicial.
         */
        this.captureMainSnapshot();
      } finally {
        this.initializing =
          previousInitializingState;
      }
    },

    saveMainIntraoperative() {
      return this.apolloMutate({
        mutation: require(
          "@/graphql/surgery/save_surgery_intraoperative.gql"
        ),

        variables: {
          surgeryId: this.surgery.id,

          surgeonId: this.lodash.get(
            this.surgeon,
            "id",
            ""
          ),

          pharmaceuticalId:
            this.lodash.get(
              this.pharmaceutical,
              "id",
              ""
            ),

          floatingId: this.lodash.get(
            this.floating,
            "id",
            ""
          ),

          instrumentatorId:
            this.lodash.get(
              this.instrumentator,
              "id",
              ""
            ),

          description: this.description,

          observation: this.observation,

          assistantIds: this.lodash.map(
            this.assistants || [],
            "id"
          ),
        },
      });
    },

    async saveSurgeryIntraoperative() {
      if (
        this.disabled ||
        this.saving ||
        !this.hasUnsavedChanges
      ) {
        return;
      }

      this.saving = true;
      this.saveError = null;

      try {
        /*
         * Salva o formulário principal apenas
         * quando ele foi efetivamente alterado.
         */
        if (this.mainDirty) {
          const mainSnapshotBeingSaved =
            this.createMainSnapshot();

          await this.saveMainIntraoperative();

          this.descriptionModel = null;
          this.descriptionTemplate = null;

          /*
           * O estado enviado passa a ser o novo
           * baseline.
           */
          this.initialMainSnapshot =
            mainSnapshotBeingSaved;

          /*
           * Caso o operador tenha alterado algum
           * campo durante a request, mainDirty
           * continuará verdadeiro.
           */
          this.updateMainDirtyState();
        }

        /*
         * O filho verifica internamente se
         * possui alterações antes de executar
         * sua mutation.
         */
        if (
          this.$refs.anesthesia &&
          typeof this.$refs.anesthesia
            .save === "function"
        ) {
          await this.$refs.anesthesia.save();
        }

        /*
         * Um único refresh depois de todas as
         * mutations.
         */
        await this.refreshSurgery();
      } catch (error) {
        this.saveError = error;

        console.error(
          "Erro ao salvar intraoperatório:",
          error
        );
      } finally {
        this.saving = false;
      }
    },

    choseDescriptionTemplate() {
      if (
        !this.descriptionTemplate
          ?.description
      ) {
        return;
      }

      if (!this.description) {
        this.description =
          this.descriptionTemplate.description;
      } else {
        this.description += "\n";
        this.description +=
          this.descriptionTemplate.description;
      }

      this.handleMainChange();
    },

    updateProstheses(prostheses) {
      this.surgery.surgeryIndication.prostheses =
        prostheses;
    },
  },
};
</script>

<style lang="scss" scoped></style>
